<template>
  <div id="app">
    <header class="survey-header">
      <div class="header-top">
        <div class="header-content">
          <router-link to="/" class="logo-link">
            <img src="./assets/AECOM_Logo_Black_RGB.svg" alt="AECOM Logo" class="logo">
            
          </router-link>
          <h1>{{ t({
            fr: 'Inventaire des ouvrages de protection contre les inondations du Canada',
            en: "Canada's Flood Defence Systems Inventory"
          }) }}</h1>
          <img src="https://www.canada.ca/etc/designs/canada/cdts/gcweb/v4_0_47/wet-boew/assets/sig-blk-en.png" alt="Government of Canada Logo" class="logo">
        </div>
      </div>
      <div class="header-bottom">
        <nav class="header-nav">
          <router-link to="/" class="nav-link">{{ t({ fr: 'Accueil', en: 'Home' }) }}</router-link>
          <router-link to="/about-aecom" class="nav-link">{{ t({ fr: "À propos d'AECOM", en: 'About AECOM' }) }}</router-link>
          <router-link to="/privacy" class="nav-link">{{ t({ fr: 'Données personnelles', en: 'Privacy' }) }}</router-link>
          <router-link to="/survey" class="nav-link survey-link">{{ t({ fr: 'Formulaire', en: 'Submission form' }) }}</router-link>
        </nav>
        <div class="header-lang">
          <LanguageToggle />
        </div>
      </div>
    </header>
    <main>
      <router-view />
    </main>
    <footer class="survey-footer">
      <div class="footer-content">
        <div class="footer-links">
          <div class="footer-section">
            <router-link to="/" class="footer-link">{{ t({ fr: 'Accueil', en: 'Home' }) }}</router-link>
            <router-link to="/about-aecom" class="footer-link">{{ t({ fr: "À propos d'AECOM", en: 'About AECOM' }) }}</router-link>
          </div>
          <div class="footer-section">
            <router-link to="/privacy" class="footer-link">{{ t({ fr: 'Données personnelles', en: 'Privacy' }) }}</router-link>
            <router-link to="/survey" class="footer-link">{{ t({ fr: 'Formulaire', en: 'Submission form' }) }}</router-link>
          </div>
        </div>
        <div class="footer-logo">
          <img src="./assets/AECOM_Logo-Tagline Lockup_Reverse_RGB_FR.svg" alt="AECOM Logo" class="footer-logo-img">
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-copyright">
          {{ t({
            fr: '© 2026 AECOM — sous contrat avec Ressources naturelles Canada. Tous droits réservés.',
            en: '© 2026 AECOM — under contract with Natural Resources Canada. All rights reserved.'
          }) }}
        </div>
        <div class="footer-legal"></div>
      </div>
    </footer>
  </div>
</template>

<script>
import LanguageToggle from './components/LanguageToggle.vue'
import { t } from './i18n/index.js'

export default {
  name: 'App',
  components: { LanguageToggle },
  methods: { t }
}
</script>

<style>
/* AECOM Brand Colors (full palette imported in main.js from
   assets/aecom-colors.css; these aliases keep older var names working). */
:root {
  --aecom-earth-green: #008768;
  --aecom-lime-green: #aecc53;
  --aecom-midnight-teal: #00353e;
  --aecom-black: #000000;
  --aecom-white: #ffffff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--aecom-midnight-teal);
  background-color: #cfdfd7;
  min-height: 100vh;
}

/* Header split styles */
.survey-header {
  box-shadow: 0 2px 10px rgba(0, 53, 62, 0.1);
  border-bottom: none;
}
.header-top {
  background: var(--aecom-white);
  padding: 5px 20px 10px 20px;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.logo-link {
  text-decoration: none;
}
.logo {
  height: 40px;
  filter: none;
}
.survey-header h1 {
  color: var(--aecom-earth-green);
  font-size: 1.4rem;
  margin: 0;
  font-weight: 600;
  text-shadow: none;
  flex: 1;
  text-align: center;
  padding: 0 30px;
}
.header-bottom {
  background: var(--aecom-midnight-teal);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.header-nav {
  display: flex;
  gap: 25px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px 0;
}
.header-lang {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.nav-link {
  color: var(--aecom-white);
  text-decoration: none;
  padding: 9px 16px;
  border-radius: 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}
.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}
.nav-link.router-link-active {
  background-color: var(--aecom-lime-green);
  color: var(--aecom-midnight-teal);
  font-weight: 600;
  transform: translateY(-1px);
}

.banner {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.survey-footer {
  background-color: var(--aecom-midnight-teal);
  color: var(--aecom-white);
  margin-top: 40px;
  padding: 40px 20px 20px 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.footer-links {
  display: flex;
  gap: 60px;
  flex: 1;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  color: var(--aecom-white);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--aecom-lime-green);
}

.footer-logo {
  flex-shrink: 0;
}

.footer-logo-img {
  height: 40px;
  filter: brightness(0) invert(1);
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.85rem;
}

.footer-copyright {
  color: rgba(255, 255, 255, 0.8);
}

footer {
  margin-top: 40px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .header-top {
    padding: 15px 15px 8px 15px;
  }
  .header-content {
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
  }
  .logo {
    margin-right: 0;
    margin-bottom: 10px;
    height: 50px;
  }
  .survey-header h1 {
    font-size: 1.1rem;
  }
  .header-bottom {
    padding: 8px 15px;
    flex-direction: column;
    gap: 6px;
  }
  .header-lang {
    position: static;
    transform: none;
  }
  .header-nav {
    gap: 15px;
    justify-content: center;
    padding: 8px 0;
  }
  .nav-link {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
  }
  .footer-links {
    gap: 40px;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .header-nav {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .nav-link {
    width: 220px;
    text-align: center;
  }
  .footer-links {
    flex-direction: column;
    gap: 25px;
    align-items: center;
  }
  .footer-section {
    align-items: center;
  }
}
</style>
